import * as actions from './actionCatalog';
import * as http from '../http';
import { Dispatch } from 'redux';
import defaultDebounce from './debouncer';
import { WorklistNode, WorklistScriptMapping } from '../reducers/worklistReducer';

const regularGetWorklistNodes = (dispatch: Dispatch) => http.get<WorklistNode[]>(actions.GET_WORKLIST_NODES, dispatch);
const debouncedGetWorklistNodes = defaultDebounce(regularGetWorklistNodes);

const regularGetWorklistScriptsMappings = (dispatch: Dispatch) =>
  http.get<WorklistScriptMapping[]>(actions.GET_WORKLIST_SCRIPTS_MAPPINGS, dispatch);
const debouncedGetWorklistScriptsMappings = defaultDebounce(regularGetWorklistScriptsMappings);

export const getWorklistNodes = () => debouncedGetWorklistNodes;
export const forceGetWorklistNodes = () => regularGetWorklistNodes;

export const getWorklistScriptsMappings = () => debouncedGetWorklistScriptsMappings;
export const forceGetWorklistScriptsMappings = () => regularGetWorklistScriptsMappings;

export function insertWorklistNode(node: WorklistNode) {
  console.log('inserting worklist node', node);
  return http.post<void>(actions.WORKLIST_NODES, node);
}

export function updateWorklistNode(node: WorklistNode) {
  console.log('updating worklist node', node);
  return http.put<void>(actions.WORKLIST_NODES, node);
}

export function deleteWorklistNode(node: WorklistNode) {
  console.log('deleting worklist node', node);
  return http.del<void>(actions.WORKLIST_NODES, node);
}

export function testWorklist(date: String, aeTitle: String, modality: String) {
  const payload = {
    date,
    aeTitle,
    modality,
  };

  return http.post<Map<string, number>>(actions.TEST_WORKLIST, payload);
}

export function insertWorklistScriptMapping(mapping: WorklistScriptMapping) {
  return http.post<void>(actions.WORKLIST_SCRIPTS_MAPPINGS, mapping);
}

export function updateWorklistScriptMapping(mapping: WorklistScriptMapping) {
  return http.put<void>(actions.WORKLIST_SCRIPTS_MAPPINGS, mapping);
}

export function updateWorklistScriptMappingOrders(newOrders: { pk: number; orderIndex: number }[]) {
  return http.put<void>(`${actions.WORKLIST_SCRIPTS_MAPPINGS.path}/order`, newOrders);
}

export function deleteWorklistScriptMapping(pk: number) {
  return http.del<void>(actions.WORKLIST_SCRIPTS_MAPPINGS, { pk });
}
